import Arrow from '../../visuals/Icons/Arrow';

interface IListItem {
  label: string;
  value: string;
}
interface ISelectListProps {
  onChange: React.ChangeEventHandler<HTMLSelectElement>;
  items: IListItem[];
  UNSAFE_className?: string;
}

const SelectList: React.FC<ISelectListProps> = ({
  onChange,
  items,
  UNSAFE_className = '',
}) => {
  return (
    <>
      <div
        className={`tw-relative tw-w-full tw-max-w-[300px] ${UNSAFE_className}`}
      >
        <select className="tw-appearance-none" onChange={onChange}>
          {items.map((item) => {
            return (
              <option value={item.value} key={item.value}>
                {item.label}
              </option>
            );
          })}
        </select>
        <div
          className={`
          tw-pointer-events-none
          tw-absolute tw-right-4 tw-top-[calc(50%-9px)]
          tw-block
        `}
        >
          <Arrow headDirection={'bottom'} width={13} height={13} />
        </div>
      </div>
    </>
  );
};

export default SelectList;
